define('controllers/academy/ItemIntroductionAcademyController',['require','jquery','underscore','react','react-dom','controllers/academy/AcademyBaseController','views/academy/ItemIntroductionView.js','component!PulseIndicatorComponent','lib/GlobalEventBus','lib/Podio.Config'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');
  var React = require('react');
  var ReactDOM = require('react-dom');

  var AcademyBaseController = require('controllers/academy/AcademyBaseController');

  var ItemIntroductionView = require('views/academy/ItemIntroductionView.js');
  var PulseIndicatorComponent = require('component!PulseIndicatorComponent');

  var globalEvent = require('lib/GlobalEventBus');
  var podioConfig = require('lib/Podio.Config');

  var course = {
    'id': 'itemIntroduction',
    'isDismissed': false,
    'assignments': [
      {
        'id': 'login',
        'completed': true
      },
      {
        'id': 'fillTitle',
        'completed': false,
        'selector': '.app-fields-list #title .frame-content .value'
      },
      {
        'id': 'fillDeadline',
        'completed': false,
        'selector': '.app-fields-list #deadline .frame-content .value'
      },
      {
        'id': 'enterModifyTemplate',
        'completed': false,
        'selector': '.item-topbar .edit-template'
      },
      {
        'id': 'addTextField',
        'completed': false,
        'selector': ".fields-list li[data-field-type='text'] .field-name"
      },
      {
        'id': 'renameTextFieldToDescription',
        'completed': false,
        'selector': '.app-fields-list .large-text-field .frame-content .value'
      },
      {
        'id': 'saveTemplate',
        'completed': false,
        'selector': '.field-picker-footer .finish-template-edit-button'
      },
      {
        'id': 'fillDescription',
        'completed': false,
        'selector': '.app-fields-list .large-text-field .frame-content .value .blank-placeholder'
      },
      {
        'id': 'createItem',
        'completed': false,
        'selector': '.item-create-footer .save-item-button'
      }
    ]
  };

  // DEBUGGING!

  /*
  window.acadebug = {
    _index: 0,

    fns: [
      function () {
        globalEvent.trigger('academy.itemIntroduction.fillTitle');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.fillDeadline');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.fillResponsible');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.enterModifyTemplate');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.addTextField');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.renameTextFieldToDescription');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.saveTemplate');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.fillDescription');
      },
      function () {
        globalEvent.trigger('academy.itemIntroduction.createItem');
      }
    ],

    open: function () {
      globalEvent.trigger('academy.open.itemIntroduction');
    },

    next: function () {
      this.fns[this._index++]();
    },

    reset: function () {
      var User = require('models/Podio.Models.User');
      var user = new User();

      return $.when(user.removeProperty('academy_itemIntroduction'), user.removeProperty('academy_intro_overlay'));
    }
  };

  setTimeout(function () {
    ItemIntroductionAcademyController.prototype._isAcademyIntroApp = function () { return true; };
    window.acadebug.reset();

    window.academyItemIntroduction = new ItemIntroductionAcademyController();
    window.academyItemIntroduction.openView();
  }, 500);
  */

  var ItemIntroductionAcademyController = AcademyBaseController.extend({
    initialize: function(options) {
      this.initialRender = true;

      this._super(course);
    },

    _bindEvents: function() {
      this.eventBus.on('academy:introduction:open', this.openView.bind(this), this);
      this.eventBus.on('academy:didClose', this.closeView.bind(this), this);

      this.eventBus.on('courseUpdate', this._renderPulseIndicator.bind(this), this);

      ['item.main.ready', 'item.enterEditTemplate', 'item.leaveEditTemplate'].forEach(function(evt) {
        globalEvent.on(evt, this._renderPulseIndicator.bind(this), this);
      }.bind(this));

      this._super();
    },

    _isAcademyIntroApp: function(appModel) {
      appModel = appModel || this.appModel;

      if (!appModel) {
        return false;
      }

      if (appModel.get('owner').user_id !== podioConfig.user.user_id) {
        return false;
      }

      if (!podioConfig.academy_intro_app_ids) {
        return false;
      }

      return _.contains(podioConfig.academy_intro_app_ids, appModel.get('original'));
    },

    openView: function(callback, appModel) {
      // Is triggered for all items, but should only open for academy apps
      if (! this._isAcademyIntroApp(appModel)) {
        return;
      }

      if (appModel) {
        this.appModel = appModel;
      }

      this.node = document.querySelector('.academy-introduction-placeholder');
      if (!_.isElement(this.node)) {
        this.node = this._createNodePlaceholder('academy-introduction-placeholder');
      }

      this.initialRender = false;

      var options = {
        eventBus: this.eventBus,
        course: this.course
      };

      if (_.isUndefined(this.view)) {
        this.view = ReactDOM.render(React.createElement(ItemIntroductionView, options), this.node, callback);
      }

      this._super();
    },

    closeView: function() {
      this._disposePulseIndicatorView();

      this._super();
    },

    _createNodePlaceholder: function(className) {
      var node = document.createElement('div');
      node.className = className;

      document.body.appendChild(node);

      return node;
    },

    _renderPulseIndicator: function(courses) {
      if (_.isUndefined(this.appModel)) {
        return;
      }

      $(document.body).trigger('click');

      var node = document.querySelector('.pulse-indicator-placeholder');
      if (!_.isElement(node)) {
        node = this._createNodePlaceholder('pulse-indicator-placeholder');
      }

      var uncompletedAssignments = this.course.assignments.filter(function(assignment) {
        return assignment.completed === false;
      });

      var completedAssignments = this.course.assignments.filter(function(assignment) {
        return assignment.completed === true;
      });

      var lastCompletedStep = _.indexOf(this.course.assignments, _.last(completedAssignments));
      var assignmentByIndex = this.course.assignments[lastCompletedStep + 1];
      var currentAssignment = _.isDefined(assignmentByIndex) ? assignmentByIndex : _.first(uncompletedAssignments);

      if (_.isUndefined(this.pulseIndicatorView)) {
        this.pulseIndicatorView = ReactDOM.render(React.createElement(PulseIndicatorComponent), node);
      }

      if (this.pulseIndicatorView.isMounted()) {
        this.pulseIndicatorView.setState({assignment: currentAssignment});
      }
    },

    _disposePulseIndicatorView: function() {
      if (_.isDefined(this.pulseIndicatorView) && this.pulseIndicatorView.isMounted()) {
        ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this.pulseIndicatorView));

        delete this.pulseIndicatorView;
      }
    },

    handleEvent: function(assignment, appModel) {
      // Is triggered for all items, but should only open for academy apps
      if (! this._isAcademyIntroApp(appModel)) {
        return;
      }

      this._super(assignment);

      if (this.isCompleted()) {
        this.pulseIndicatorView.setState({
          assignment: {
            completed: false,
            selector: '.item-topbar .breadcrumb .app-name'
          }
        });
      }
    }
  });

  return ItemIntroductionAcademyController;
});

